// @flow
import React from 'react'
import styled from 'styled-components'

type Props = {
  value: number,
  onChange: (n:number) => void
}

export default function Number ({value, onChange}:Props) {
  return (
    <Wrapper>
      <button onClick={onChange(value-1)}>-</button>
      <span>{value-2}</span>
      <button onClick={onChange(value+1)}>+</button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: #c3cfd5;
  border: 1px solid grey;
  border-radius: 3px;
  display: flex;


  > button {
      border: none;
      background: none;
      padding: 5px 10px;
      font-size: 16px;
      cursor: pointer;
  }

  > span {
    padding: 5px 10px;
    background white;
    border-left: 1px solid grey;
    border-right: 1px solid grey;
  }

`


// WEBPACK FOOTER //
// ./src/components/Number.js